module.exports = __webpack_public_path__ + "static/media/prototype-illustration.8e16a939.svg";